// Horde challenges: wave after wave in one arena, with the arena itself turning on you: rocks fall from the sky,
// the ground erupts, and a ring closes in. The first one, the Meadow Stampede, is a taste of what bigger
// trials will be like: Ranger Hollis runs it from the Meadowlands, for any level (and any party).
export type Hazard = 'rocks' | 'quake' | 'shrink';
export interface HordeDef {
  id: string; name: string; zone: string;
  /** Who runs it and where they stand (tiles). */
  host: string; at: [number, number];
  /** The creatures of each wave (the last is the big one). */
  waves: string[][];
  /** From which wave each hazard starts (0 = the first). */
  hazards: Partial<Record<Hazard, number>>;
  blurb: string;
}
export const HORDES: HordeDef[] = [
  { id: 'stampede', name: 'Meadow Stampede', zone: 'meadow', host: 'Ranger Hollis', at: [35, 7],
    waves: [['bunny', 'bunny', 'puff'], ['beetle', 'bunny', 'bunny', 'puff'], ['beetle', 'beetle', 'puff', 'puff', 'bunny'], ['stampede_buck', 'bunny', 'bunny']],
    hazards: { rocks: 1, quake: 2, shrink: 3 },
    blurb: 'Four waves, each bigger than the last. Watch the sky: rocks fall where the red circles are. Then the ground goes, and then the ring closes in.' },
];
export const hordeDef = (id: string) => HORDES.find(h => h.id === id);
/** How close to the host you must be to start (tiles). */
export const HORDE_RANGE_TILES = 4;
/** Each hazard: its name, how often (ticks), its circle (pixels), how long it warns you (ticks), and how hard it
 *  hits (a share of your health: so it means the same at any level). The ring: smallest it gets (a share of where it
 *  starts), and what standing outside costs every second. */
export const HAZARDS = {
  rocks: { name: 'Falling Rocks', every: 60 * 5, r: 18, warn: 80, hurt: 0.16 },
  quake: { name: 'Eruption', every: 60 * 8, r: 32, warn: 110, hurt: 0.24 },
  shrink: { name: 'The ring', min: 0.42, closeTicks: 60 * 25, hurtPerSec: 0.05 },
} as const;
/** Between waves: a breather (a share of health and magic back). */
export const WAVE_HEAL = 0.15;
